import React, { useEffect, useState } from "react";
import { API } from "../constants";

/**
 * Lightweight system readiness badge.
 * Checks the API reachability and displays a small status pill.
 */
function SystemReadinessBadge() {
  const [status, setStatus] = useState("checking"); // checking | ready | issue
  const [lastChecked, setLastChecked] = useState(null);

  const statusConfig = {
    checking: { color: "#6c757d", label: "Checking…" },
    ready: { color: "#28a745", label: "System Ready" },
    issue: { color: "#dc3545", label: "System Issue" },
  };

  const checkHealth = async () => {
    setStatus("checking");
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      const response = await fetch(`${API}/banks/`, { signal: controller.signal });
      clearTimeout(timeout);
      if (response.status === 429) {
        // Avoid contributing to throttling loops; show issue and back off.
        setStatus("issue");
        return;
      }
      if (response.ok) {
        setStatus("ready");
      } else {
        setStatus("issue");
      }
    } catch (error) {
      setStatus("issue");
    } finally {
      setLastChecked(new Date());
    }
  };

  useEffect(() => {
    checkHealth();
    // Polling is helpful on live, but on localhost it can amplify throttling.
    const isLocalhost =
      typeof window !== "undefined" &&
      window.location &&
      (String(window.location.hostname || "").toLowerCase() === "localhost" ||
        String(window.location.hostname || "") === "127.0.0.1");

    const interval = setInterval(checkHealth, isLocalhost ? 120000 : 30000);
    return () => clearInterval(interval);
  }, []);

  const { color, label } = statusConfig[status];

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 10px",
        borderRadius: "999px",
        background: "#f8f9fa",
        border: "1px solid #e5e7eb",
        fontSize: "0.9rem",
        color: "#212529",
      }}
      aria-label={`System status: ${label}`}
    >
      <span
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          background: color,
          display: "inline-block",
        }}
      />
      <span style={{ fontWeight: 600 }}>{label}</span>
      {lastChecked && (
        <span style={{ fontSize: "0.75rem", color: "#6c757d" }}>
          Checked {lastChecked.toLocaleTimeString()}
        </span>
      )}
    </div>
  );
}

export default SystemReadinessBadge;

